import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import { useGetRolesQuery } from '../../../../../redux/services/roles';
import {
  useGetUserQuery,
  useGetUsersQuery,
  useSaveUserMutation,
} from '../../../../../redux/services/users';
import UserForm from './UserForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { formattedFullName } from '../../../../../utils/helpers/CommonHelper';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UsersEdit = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: userDetail, isLoading: isLoadingUser } = useGetUserQuery(id);
  const { data: roles, isLoading: isLoadingRoles } = useGetRolesQuery();
  const [saveUser, { isSuccess: saveSuccess }] = useSaveUserMutation();
  const { refetch } = useGetUsersQuery();

  useEffect(() => {
    document.title = t('Úprava FRI používateľa') + ' - FRI CMS';
  }, []); // Runs on mount

  useEffect(() => {
    if (saveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsUsers);
      refetch();
    }
  }, [saveSuccess]);

  if (isLoadingUser || isLoadingRoles) {
    return <Spinner />;
  }

  const title = `${t('Správa rolí používateľa')}`;

  const sortedRolesIds = [...(userDetail?.roles || [])]
    .sort((left, right) => (left.name || '').localeCompare(right.name || '', 'sk'))
    .map((role) => role.id);

  const initials = {
    teacher: userDetail?.teacher || null,
    newsletters: !!userDetail?.newsletters,
    ldap_mail: !!userDetail?.ldap_mail,
    fullName: formattedFullName(userDetail),
    rolesFullName: formattedFullName(userDetail),
    mail: userDetail.mail,
    chosenRolesIds: sortedRolesIds,
    ipStudyProgramIds: userDetail?.ip_coordinated_study_program_ids || [],
  };

  return (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsUsers}
        backUrlTooltip={t('Používatelia')}
        permissionsBasic={'users'}
      />
      <div style={{ margin: '10px' }}>
        <UserForm
          roles={roles}
          initials={initials}
          onSubmit={(values) => {
            const body = {
              description_sk: values.teacher?.description_sk,
              description_en: values.teacher?.description_en,
              newsletters: values.newsletters,
              ldap_mail: values.ldap_mail,
              roles_ids: JSON.stringify(values.chosenRolesIds),
              ip_study_program_ids: values.ipStudyProgramIds,
              mail: values.mail,
            };
            saveUser({ body, id });
          }}
        />
      </div>
    </>
  );
};

export default UsersEdit;
